<script setup lang="ts">
import type { MenuGroup } from '~/shared/lib/menu-links.const';

defineProps<{
  group: MenuGroup;
}>();

const emit = defineEmits(['closeMenu']);
</script>

<template>
  <div :class="$style.links">
    <div :class="$style.links__title">{{ group.title }}</div>
    <NuxtLink
      v-for="(item, key) in group.links"
      :key="`menuLinksItem_${key}`"
      :to="item.link"
      :target="item.newTab ? '_blank' : undefined"
      :title="item.title"
      :class="$style.links__link"
      @click="emit('closeMenu')"
    >
      <Icon
        v-if="item.logo"
        :name="`my-icon:${item.logo}`"
        :class="$style.links__linkLogo"
      />
      <span v-else :class="$style.links__linkText">
        {{ item.title }}
      </span>
      <Icon
        v-if="item.badge"
        :name="`my-icon:i-badge-${item.badge}`"
        :width="47"
        :height="20"
      />
    </NuxtLink>
  </div>
</template>

<style module lang="scss">
.links {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--space-1-5x);
  max-width: 100%;

  &__title {
    @include text_caption1_caps;
    color: var(--color-gray-text);
  }

  &__link {
    @include text_body2;
    color: var(--color-black-1);
    text-decoration: none;
    align-self: flex-start;
    max-width: 100%;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover .links__linkText,
    &:focus-visible .links__linkText {
      background-size: 100% 1px;
    }
  }

  &__linkLogo {
    display: block;
    width: auto;
    height: 16px;
  }

  &__linkText {
    background-image: linear-gradient(currentColor, currentColor);
    background-position: 0 100%;
    background-repeat: no-repeat;
    background-size: 0 1px;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    transition: background-size 300ms cubic-bezier(0.85, 0, 0, 1);
  }
}
</style>
